module.exports = __webpack_public_path__ + "img/logo-light.1cf93b2c.png";